export const userIsReviewer = reviewer => {
	return reviewer.account_accepted === 3;
};



// WEBPACK FOOTER //
// ./src/utils/reviewerHelpers.js